module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/172-st-lucia-fd45bb38b4f2954da8ec7479b6e79000.svg";